const tr = {
    scanAddSuccess: '掃描單新增成功',
    scanAddFail: '掃描單新增失敗',
    tip: '提示',
    delScanTip1: '你確認要刪除這個掃描單嗎？刪除後數據將無法恢復。',
    scanDelSuccess: '掃描單刪除成功',
    addScan: '新增掃描單',
    scanCount: '共掃描{{count}}件商品',
    oprtName: '操作人: {{name}}',
    enterCode: '請輸入條碼',
    cancel: '取消',
    confirm: '確認',
    sameCheck: '重複項檢查',
    conIn: '確定入庫',
    conOut: '確定出庫',
    addScanTip:"數據默認以'空格'和'回車'進行分割，並且在輸入完成後會將重複條碼進行刪除。",
    scanSheet1: '掃描單1',
    sameBarcodeTip1: '同一商品中存在條碼重複，請修改數據後再次提交。',
    sameBarcodeTip2: '掃描單中存在重複條碼，請檢查數據再次提交。',
    confirmClearData: '當前頁面已有內容，確認清空數據嗎？',
    scanSheetNum: '掃描單{{num}}',
    scanSheetCount: '掃描單{{count}}',
    fillBarcodeFirst: '請先填寫條碼後再新增數據。',
    selProductForBarcode: '商品：',
    selProductForBarcodePl: '請為條碼選擇商品',
    clear: '清除',
    addNew: '新增',
    scanSheetData: '掃描單數據',
    addScanMax: '最多只能新增{{num}}條掃描單',
    scanNumExceedMax: '條碼數量超過最大限制',
    scanNumExceedMaxTip: '最多只能輸入{{num}}個條碼.',
    residueBarcodeNum: '剩餘可添加{{residueNum}}個條碼，請對數據進行修改後再次提交.',
    confirmDelBarcodesNum: '確認刪除選中的{{delNum}}個條碼嗎？',
    delText: '刪除',
    saveText: '保存',
    saveAndAdd: '保存並新增',
    addBarcodes: '添加條碼',
    delBarcodes: '刪除條碼',
    notFoundBarcodes: '未査詢到條碼',
    confirmClearDataTip: '當前頁面已有內容未保存，確認刪除嗎？',
    searchBarcodePlaceholder: '請輸入條碼蒐索',
    notSelectedBarcode: '當前未勾選刪除條碼',
    noDelScanSheet: '僅剩一條數據時為默認數據，不可刪除。',
    butDelTooltip: '清空當前商品和條碼數據',
    butSaveTooltip: '保存當前掃描單數據',
    butSaveAndAddTooltip: '保存掃描單數據並添加新的掃描單',
    manufactureBarcode: '批量生成條碼',
    barcodeNotEmpty: '條碼數據不可為空',
    saveScanTip: '請先保存當前掃描單',
    barcodePrefix: '條碼首碼',
    barcodeSuffix: '條碼尾碼',
    barcodeStartNum: '條碼起始數位',
    barcodeEndNum: '條碼結束數位',
    barcodeMaxCount: '最大生成數量限制（{{maxCount}}個）',
    generateBarcode: '生成條碼',
    scanDataFillTip: '請將已有掃描單數據進行填寫',
    allCheckBarcodes: '全選',
    endLessThanStart: '結束數位不能小於起始數位',
    selectProductTip: '請選擇商品',
    barcodeTip: '請填寫條碼',
    productAndBarcodeTip: '請選擇商品和填寫條碼',
    delInInventory: '刪除並確定入庫',
    delOutInventory: '刪除並確定出庫',
    selectPl: '請選擇',
};

export default tr;